import { get } from "@/services/axiosUitils";

const base = "/menu/menus/";

export interface MenuItem {
  id: string;
  path: string;
  title: string;
  icon_url?: string;
  children?: MenuItem[];
}

class MenuService {
  listMenus = async (): Promise<MenuItem[]> => {
    return await get<MenuItem[]>(base);
  };
}

export default new MenuService();
